export enum DefaultParamsSelectorTypes {
  GetAppliedDefaultParams = '[DefaultParams] Get Applied Default Params',
}
